import { Script } from "gatsby"
import useSocialMedia from "@utils/useSocialMedia"

const StructuredData = () => {
  const socialMedia = useSocialMedia()

  return (
    <>
      <Script type="application/ld+json">{`
      {
        "@context": "http://schema.org/",
        "@type": "Organization",
        "name": "Fastly",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "San Francisco, CA",
          "postalCode": "94107",
          "streetAddress": "475 Brannan St #300"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-844-432-7859",
          "contactType": "customer service"
        },
        "url": "https://www.fastly.com",
        "logo": "https://www.fastly.com/img/og-image-lg.png?canvas=1200:630&width=1200&height=630&fit=bounds&bg-color=FFFFFF",
        "sameAs": [
          "${socialMedia.facebook}",
          "${socialMedia.twitter}",
          "https://en.wikipedia.org/wiki/Fastly",
          "https://www.youtube.com/user/FastlyCDN",
          "${socialMedia.linkedin}",
          "https://vimeo.com/fastly"
        ]
      }
    `}</Script>
      <Script type="application/ld+json">{`
      {
        "@context": "http://schema.org",
        "@type": "Corporation",
        "name": "Fastly",
        "url": "https://www.fastly.com",
        "description": "Fastly’s edge cloud platform helps the world’s most
        popular digital businesses keep pace with their customer expectations
        by delivering fast, secure, and scalable online experiences."
      }
    `}</Script>
    </>
  )
}

export default StructuredData
